/**
 * Check if the language pair is valid
 * Should be an array of 2 elements
 * Language slug should be at least 2 characters long
 * Should not be the same Language
 *
 * @param languagePair
 */
export const isLanguagesPairValid = (languagePair?: (string | undefined)[]): boolean => {
    if (!languagePair) {
        return false;
    }

    return (
        languagePair.length === 2 &&
        (languagePair as unknown as string[]).every((lan) => lan?.length > 1) &&
        languagePair[0] !== languagePair[1]
    );
};
